enum QueryKeyNamespace {
  Reports = 'reports',
  Posts = 'posts',
  Insights = 'insights',
  TextEditor = 'textEditor',
  Dashboard = 'dashboard',
  BrandHub = 'brand-hub',
  ContentPlan = 'contentPlan',
  Settings = 'settings',
  SocialLogin = 'socialLogin',
  Bio = 'bio',
  Analytics = 'analytics',
}

type Namespace = QueryKeyNamespace | `${QueryKeyNamespace}`;
type Schema = string | string[];
type Keys = readonly unknown[] | unknown;

export type QueryKeyType = ReturnType<typeof QueryKey>;

export const QueryKey = (
  namespace: Namespace,
  schema: Schema,
  keys: Keys = [],
) => {
  const schemas = Array.isArray(schema) ? schema : [schema];

  return [namespace, ...schemas, keys] as const;
};

export const PostsQueryKey = (schema: Schema, keys?: Keys) =>
  QueryKey(QueryKeyNamespace.Posts, schema, keys);

export const InsightsQueryKey = (schema: Schema, keys?: Keys) =>
  QueryKey(QueryKeyNamespace.Insights, schema, keys);

export const DashboardQueryKey = (schema: Schema, keys?: Keys) =>
  QueryKey(QueryKeyNamespace.Dashboard, schema, keys);

export const ContentPlanQueryKey = (schema: Schema, keys?: Keys) =>
  QueryKey(QueryKeyNamespace.ContentPlan, schema, keys);

export const BrandHubQueryKey = (schema: Schema, keys?: Keys) =>
  QueryKey(QueryKeyNamespace.BrandHub, schema, keys);

export const SocialLoginQueryKey = (schema: Schema, keys?: Keys) =>
  QueryKey(QueryKeyNamespace.SocialLogin, schema, keys);

export const ReportsQueryKey = (schema: Schema, keys?: Keys) =>
  QueryKey(QueryKeyNamespace.Reports, schema, keys);

export const SettingsQueryKey = (schema: Schema, keys?: Keys) =>
  QueryKey(QueryKeyNamespace.Settings, schema, keys);

export const BioQueryKey = (schema: Schema, keys?: Keys) =>
  QueryKey(QueryKeyNamespace.Bio, schema, keys);
export const AnalyticsQueryKey = (schema: Schema, keys?: Keys) =>
  QueryKey(QueryKeyNamespace.Analytics, schema, keys);
